//
// Simple particle effect on title
//

particleManager = {};
particleManager.emitters = {};
particleManager.uniqueID = 0;

particleManager._getFilesRequired = function (json) {
  if (typeof json.mask !== 'undefined') {
    return [ReflexLoader.rootResDir + json.mask, ReflexLoader.rootResDir + json.textureFilename];
  } else {
    return [];
  }
};

particleManager._createParticleEmitter = function (json) {
  var container = new PIXI.Container();
  container.emitterContainer = new PIXI.Container();
  container.addChild(container.emitterContainer);

  return container;
};

particleManager._initialiseParticleEmitter = function (json, container) {
  // Mask?
  if (typeof json.mask !== 'undefined') {
    var mask = new PIXI.Sprite.fromImage(gdk.ammendResourceName(ReflexLoader.rootResDir + json.mask));
    container.addChild(mask);
    container.mask = mask;
  }

  if (checkForUndefined(json.autoCleanup)) json.autoCleanup = false;
  if (checkForUndefined(json.emit)) json.emit = true;

  // Read in emitter definition
  var emitterDefinition = resourceManager.particleEmmitterDefinitions[json.emitterDefinition];
  if (checkForUndefined(emitterDefinition)) {
    console.log('Emitter definition ' + json.emitterDefinition + ' was not found');
  }

  let includesAnimatedParticles = false;
  // Create texture for particles
  var texture;
  if (json.textureFilename) {
    texture = new PIXI.Texture.fromImage(gdk.ammendResourceName(ReflexLoader.rootResDir + json.textureFilename));
  } else if (json.textureList) {
    texture = [];
    json.textureList.forEach(function (item) {
      if (textureParser.textureLists[item] !== undefined) {
        includesAnimatedParticles = true;
        const textures = textureParser.getTextureList(json.textureList);
        let animationInfo = {};
        animationInfo.framerate = 25;
        animationInfo.loop = true;
        animationInfo.textures = [];
        for (let i = 0; i < textures.length; ++i) {
          animationInfo.textures.push(textures[i].baseTexture.imageUrl);
        }
        texture.push(animationInfo);
      } else {
        if (includesAnimatedParticles) {
          console.log('Error: Mixing animated sprites with non animated sprites in particle definition.');
        }
        texture.push(new PIXI.Texture.fromImage(gdk.ammendResourceName(ReflexLoader.rootResDir + item)));
      }
    });
  } else {
    console.log('No texture filename or list was defined for particle effect ' + json.ID);
  }

  container.emitterContainer.scale.set(resourceManager.selectedAssetResolution.scale);

  // Create the particle emitter
  container.particleEmitter = new PIXI.particles.Emitter(container.emitterContainer, texture, emitterDefinition);
  particleManager.emitters[container.Props.FQN] = container.particleEmitter;
  container.particleEmitter.arcSize =
    container.particleEmitter.maxStartRotation - container.particleEmitter.minStartRotation;

  if (includesAnimatedParticles) {
    container.particleEmitter.particleConstructor = PIXI.particles.AnimatedParticle;
  }

  container.particleEmitter.ID = json.FQN;
  container.particleEmitter.autoCleanup = json.autoCleanup;
  container.particleEmitter.emit = json.emit;
};

particleManager.getEmitter = function (name) {
  return particleManager.emitters[name];
};

particleManager.update = function (delta) {
  var keys = Object.keys(particleManager.emitters);

  for (var i = keys.length - 1; i >= 0; i--) {
    particleManager.emitters[keys[i]].update(delta / 1000);

    if (
      particleManager.emitters[keys[i]].autoCleanup &&
      particleManager.emitters[keys[i]].emit === false &&
      particleManager.emitters[keys[i]].particleCount === 0
    ) {
      particleManager.destroyEmitter(particleManager.emitters[keys[i]].ID);
    }
  }
};

particleManager.createEmitter = function (particleEffectDefinition, parentID, x, y, autoCleanup, scale) {
  if (checkForUndefined(autoCleanup)) autoCleanup = true;
  if (checkForUndefined(x)) x = 0;
  if (checkForUndefined(y)) y = 0;
  if (checkForUndefined(scale)) scale = 1;

  var textureList = resourceManager.getConfiguration().particleEffectDefinitions[particleEffectDefinition].textures;

  var emitter = resourceManager.createObject('particleEmitter', 'ID' + particleManager.uniqueID++, parentID, {
    x: x,
    y: y,
    textureList: textureList,
    emitterDefinition: particleEffectDefinition,
    autoCleanup: autoCleanup,
    scale: scale,
  });
  return emitter;
};

particleManager.destroyEmitter = function (name) {
  if (resourceManager.generatedResources[name]) {
    resourceManager.destroyObject(name);
  } else {
    // Not found
    console.warn('Particle emitter ' + name + ' not found');
  }

  delete particleManager.emitters[name];
};

Reflex.addToUpdate(particleManager.update);
resourceManager.registerObjectType(
  'particleEmitter',
  particleManager._createParticleEmitter,
  particleManager._initialiseParticleEmitter,
  particleManager._getFilesRequired
);
